import React from 'react';

import { Section, Grid } from '@gogame/components';
import { withForm, SidePageV2 } from '@gogame/form';

import {
  CAMPAIGN_TYPE,
  CAMPAIGN_TYPE_ID,
} from 'scenes/Campaigns/components/Form/Campaign/constants';
import { costModelSchema } from 'scenes/Campaigns/components/CostModel/schema';
import { loadCostModelsEvents } from 'scenes/Campaigns/sources/fields';

import {
  TYPE,
  TYPE_ID,
  PERIODS,
  IS_FINISH_DATE_REQUIRED,
  IS_FUTURE_COST_MODEL,
  IS_UNRESTRICTED_DATES,
  TYPE_NAME,
  IS_READONLY,
  EVENT,
  CPE_ID,
  IS_SUPPORT_ACTIVITY_TYPES,
  DEFAULT_ACTIVITY_TYPE,
} from '../constants';
import CostModelPeriods from './CostModelPeriods';
import EventSelect from './EventSelect';

const CostModelForm = withForm({
  enableReinitialize: true,
  validationSchema: costModelSchema,
})(({
  values,
  onClose,
  loading,
  title,
  subTitle,
  submitForm,
  canAddPeriod,
  canRemovePeriod,
  onExited,
  open,
  entityId,
  isEdit,
  selectedEventsIds,
}) => {
  const {
    [IS_READONLY]: isReadonly,
    [TYPE]: {
      [IS_FINISH_DATE_REQUIRED]: finishDateRequired,
      [IS_FUTURE_COST_MODEL]: futureCostModel,
      [IS_UNRESTRICTED_DATES]: unrestrictedDates,
      [IS_SUPPORT_ACTIVITY_TYPES]: isSupportActivityTypes,
      [TYPE_ID]: id,
      [TYPE_NAME]: name,
      [DEFAULT_ACTIVITY_TYPE]: defaultActivityType,
    } = {},
  } = values;

  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'lg'}
    >
      <SidePageV2.Title title={title} subTitle={subTitle} entityId={entityId} />
      <SidePageV2.NewBody>
        {id === CPE_ID && (
          <Section title={'Event'} required={true}>
            <Grid container>
              <Grid item xs={6}>
                <EventSelect
                  name={EVENT}
                  source={loadCostModelsEvents}
                  depends={[`${CAMPAIGN_TYPE}.${CAMPAIGN_TYPE_ID}`]}
                  disabled={isEdit}
                  label={'Select event'}
                  selectedEventsIds={selectedEventsIds}
                  padding={0}
                />
              </Grid>
            </Grid>
          </Section>
        )}
        {name ? (
          <Section title={`Cost Model: ${name}`}>
            <CostModelPeriods
              name={PERIODS}
              typeId={id}
              isSupportActivityTypes={isSupportActivityTypes}
              defaultActivityType={defaultActivityType}
              finishDateRequired={finishDateRequired}
              futureCostModel={futureCostModel}
              unrestrictedDates={unrestrictedDates}
              canAddPeriod={canAddPeriod}
              canRemovePeriod={canRemovePeriod}
              costModelIsReadonly={isReadonly}
            />
          </Section>
        ) : null}
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton onSubmit={submitForm} />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});

export default CostModelForm;
